module.exports = __webpack_public_path__ + "cd455783/img/google.68f3823e.svg";